import {
  ClientUserUpdatePatch,
  ConfirmDeleteAccount,
  InitDeleteAccount,
  reqConfirmDeleteAccount,
  reqInitDeleteAccount,
  reqSyncClientUser,
  reqUpdateClientUser,
  reqUpdateClientUsername,
  SyncClientUser,
  UpdateClientUser,
  UpdateClientUsername,
} from '@weblite/ts-action/client-user'
import { request, requestNow } from '$setup/ws'
import { clientUserStorage } from './storage'
import * as sync from './offline-sync'
import afterSignOut from '../../hooks/after/signout'
import {
  superUserAccountIds,
  supportAccountIds,
} from '$logic/client-user/constants'
import { DeferredPromise } from '$func/deferred-promise'

export const syncClientUserPromise = new DeferredPromise<null>()

export const getClientUser = clientUserStorage.get

export async function initDeleteAccount() {
  try {
    const response = await requestNow<InitDeleteAccount>(
      reqInitDeleteAccount({}),
    )
    if (!response || !response.payload) return undefined

    return response.payload
  } catch (e) {
    return undefined
  }
}

export async function confirmDeleteAccount(mfaToken: string): Promise<boolean> {
  const res = await requestNow<ConfirmDeleteAccount>(
    reqConfirmDeleteAccount({ mfaToken }),
  )
  if (res.error) return false
  afterSignOut()
  return true
}

export async function updateClientUser(updatedFields: ClientUserUpdatePatch) {
  const unsetSync = await sync.set(updatedFields)
  await clientUserStorage.set(updatedFields)
  const res = await request<UpdateClientUser>(
    reqUpdateClientUser({ updatedFields }),
  )
  await unsetSync()
  return res
}

export async function updateClientUsername(username: string | null) {
  const res = await request<UpdateClientUsername>(
    reqUpdateClientUsername({ username }),
  )
  // TODO: error code will change later
  if ('error' in res) {
    return res.error?.code === 'repetitive-username'
      ? 'NOT_AVAILABLE'
      : 'INVALID'
  }
  await clientUserStorage.set({ username: username ?? undefined })

  return 'AVAILABLE'
}

export async function syncClientUser(): Promise<void> {
  const { item, del, release } = await sync.get()
  try {
    const res = await requestNow<SyncClientUser>(
      reqSyncClientUser({ clientUser: item }),
    )
    if (res.payload) {
      await clientUserStorage.set(res.payload)
      syncClientUserPromise.resolve(null)
    }
    await del()
  } finally {
    release()
  }
}

export function getClientUserId() {
  return getClientUser()?.id
}

export function isClientUserSupport() {
  return supportAccountIds.has(getClientUser()?.id) || getIsSuperUser()
}

export const isSuperUserEnabled = true

export function getIsSuperUser() {
  return isSuperUserEnabled && superUserAccountIds.has(getClientUser()?.id)
}
